module.exports = __webpack_public_path__ + "static/img/1@2x.dabb617.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homepage/productCase/1@2x.png
// module id = 8Mtd
// module chunks = 0